import ms from "ms";
import { makeHook } from "../../utils/makeSingleArgHook";
import getFeedsSummary, { feedsSummaryUrl } from "../requests/getFeedsSummary";
const useGetFeedsSummary = makeHook(async (personId, auth) => getFeedsSummary(personId, auth), (personId) => [feedsSummaryUrl(personId)], { refetchInterval: ms("5 minutes"), refetchIntervalInBackground: true });
export default useGetFeedsSummary;
//# sourceMappingURL=useGetFeedsSummary.js.map